import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function RecognitionOptionsDialog({
  open,
  onClose,
  onConfirm,
  useCompanyCode,
  setUseCompanyCode,
  useMarkdown,
  setUseMarkdown,
}) {
  const { t } = useLanguage();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isSmDown}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          m: isSmDown ? 0 : 2,
          borderRadius: isSmDown ? 0 : 2,
        },
      }}
    >
      <DialogTitle>{t("recognitionOptions")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("selectRecognitionOptions")}</DialogContentText>

        <MDBox mt={2}>
          <MDTypography variant="body2" fontWeight="medium" mb={1}>
            {t("companyCodeOption")}
          </MDTypography>
          <RadioGroup
            value={useCompanyCode}
            onChange={(e) => setUseCompanyCode(e.target.value === "true")}
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label={t("useCompanyCodeFromSettings")}
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label={t("extractCompanyCodeFromDocument")}
            />
          </RadioGroup>
        </MDBox>

        <MDBox mt={3}>
          <MDTypography variant="body2" fontWeight="medium" mb={1}>
            {t("recognitionMethod")}
          </MDTypography>
          <RadioGroup
            value={useMarkdown}
            onChange={(e) => setUseMarkdown(e.target.value === "true")}
          >
            <FormControlLabel value={false} control={<Radio />} label={t("traditionalMethod")} />
            <FormControlLabel value={true} control={<Radio />} label={t("markdownMethod")} />
          </RadioGroup>
          <MDTypography variant="caption" color="text" mt={1} display="block">
            {t("markdownMethodDescription")}
          </MDTypography>
        </MDBox>
      </DialogContent>
      <DialogActions
        sx={{
          px: 2,
          pb: 2,
          pt: 1,
          flexDirection: isSmDown ? "column-reverse" : "row",
          gap: 1,
        }}
      >
        <MDButton onClick={onClose} color="secondary" fullWidth={isSmDown}>
          {t("cancel")}
        </MDButton>
        <MDButton onClick={onConfirm} color="primary" fullWidth={isSmDown}>
          {t("startRecognition")}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

RecognitionOptionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  useCompanyCode: PropTypes.bool.isRequired,
  setUseCompanyCode: PropTypes.func.isRequired,
  useMarkdown: PropTypes.bool.isRequired,
  setUseMarkdown: PropTypes.func.isRequired,
};

export default RecognitionOptionsDialog;
